import { Feedback, FeedbackType, LoginLayout } from 'components_old';


export const ErrorHandler = () => {
  return (
    <LoginLayout header={<Feedback type={FeedbackType.ERROR} >An error had occured</Feedback>} />
  );
};
